const getTop15Value = (data) => {
  let top15 = [];
  for (let i = 0; i < 15; i++) {
    let biggest = null;
    for (let item of data) {
      if (
        !top15.includes(item) &&
        (biggest === null || item.average_all > biggest.average_all)
      ) {
        biggest = item;
      }
    }
    if (biggest) {
      top15.push(biggest);
    }
  }

  return Math.floor(top15[top15.length - 1]?.average_all * 100) / 100;
};

export const presetKeys = [
  'overview',
  'dailyAnalysis',
  'trendAnalysis',
  'detailed',
];

export const getPresets = (transformedData, t, analysisType) => {
  if (analysisType === 'power')
    return [
      {
        name: t('presets.overview'),
        order: [
          'favorites',
          'type',
          '__row_group_by_columns_group__',
          'occupancy',
          'daytime_start',
          'daytime_end',
          'average_all',
          'average_all_inactive_hours',
          'total_consumption_year',
          'total_consumption_last_year',
          'total_consumption_previous_year',
          'warnings',
        ],
        sortingModel: [{ field: 'average_all', sort: 'desc' }],
        rowGrouping: {
          model: ['matrikel_key'],
        },
        filterModel: {
          items: [],
        },
        columnGroupingModel: [
          {
            groupId: 'activityPatterns',
            headerName: t('columnGroups.activityPatterns.header'),
            description: t('columnGroups.activityPatterns.description'),
            children: [
              { field: 'occupancy' },
              { field: 'daytime_start' },
              { field: 'daytime_end' },
            ],
          },
          {
            groupId: 'averageConsumption',
            headerName: t('columnGroups.averageConsumption.header'),
            description: t('columnGroups.averageConsumption.description'),
            children: [
              { field: 'average_all' },
              { field: 'average_all_inactive_hours' },
            ],
          },
          {
            groupId: 'yearlyTotal',
            description: t('columnGroups.yearlyTotal.description'),
            headerName: t('columnGroups.yearlyTotal.header'),
            children: [
              { field: 'total_consumption_year' },
              { field: 'total_consumption_last_year' },
              { field: 'total_consumption_previous_year' },
            ],
          },
        ],
      },
      {
        name: t('presets.dailyAnalysis'),
        order: [
          'favorites',
          'type',
          '__row_group_by_columns_group__',
          'occupancy',
          'daytime_start',
          'daytime_end',
          'average_all',
          'average_17_to_21',
          'average_weekday_day',
          'average_all_inactive_hours',
          'inactive_active_ratio',
          'warnings',
        ],
        sortingModel: [{ field: 'average_all', sort: 'desc' }],
        rowGrouping: {
          model: ['matrikel_key'],
        },
        filterModel: {
          items: [
            {
              field: 'average_all',
              operator: '>=',
              value: getTop15Value(transformedData.portfolio_analysis_list),
            },
          ],
        },
        columnGroupingModel: [
          {
            groupId: 'activityPatterns',
            headerName: t('columnGroups.activityPatterns.header'),
            description: t('columnGroups.activityPatterns.description'),
            children: [
              { field: 'occupancy' },
              { field: 'daytime_start' },
              { field: 'daytime_end' },
            ],
          },
          {
            groupId: 'averageConsumption',
            headerName: t('columnGroups.averageConsumption.header'),
            description: t('columnGroups.averageConsumption.description'),
            children: [
              { field: 'average_all' },
              { field: 'average_17_to_21' },
              { field: 'average_weekday_day' },
              { field: 'average_all_inactive_hours' },
            ],
          },
          {
            groupId: 'consumptionRatio',
            headerName: t('columnGroups.consumptionRatio.header'),
            description: t('columnGroups.consumptionRatio.description'),
            children: [{ field: 'inactive_active_ratio' }],
          },
        ],
      },
      {
        name: t('presets.trendAnalysis'),
        order: [
          'favorites',
          'type',
          '__row_group_by_columns_group__',
          'occupancy',
          'daytime_start',
          'daytime_end',
          'average_all',
          'average_all_last_year',
          'yearly_trend',
          'yearly_trend_active',
          'yearly_trend_inactive',
          'warnings',
        ],
        sortingModel: [{ field: 'average_all', sort: 'desc' }],
        rowGrouping: {
          model: ['matrikel_key'],
        },
        filterModel: {
          items: [],
        },
        columnGroupingModel: [
          {
            groupId: 'activityPatterns',
            headerName: t('columnGroups.activityPatterns.header'),
            description: t('columnGroups.activityPatterns.description'),
            children: [
              { field: 'occupancy' },
              { field: 'daytime_start' },
              { field: 'daytime_end' },
            ],
          },
          {
            groupId: 'averageConsumption',
            headerName: t('columnGroups.averageConsumption.header'),
            description: t('columnGroups.averageConsumption.description'),
            children: [
              { field: 'average_all' },
              { field: 'average_all_last_year' },
            ],
          },
          {
            groupId: 'yearly_trend',
            headerName: t('columnGroups.yearly_trend.header'),
            description: t('columnGroups.yearly_trend.description'),
            children: [
              { field: 'yearly_trend' },
              { field: 'yearly_trend_active' },
              { field: 'yearly_trend_inactive' },
            ],
          },
        ],
      },
      {
        name: t('presets.detailed'),
        order: [
          'favorites',
          'type',
          '__row_group_by_columns_group__',
          'occupancy',
          'daytime_start',
          'daytime_end',
          'average_all',
          'average_all_last_year',
          'current_calendar_year_avg',
          'last_calendar_year_avg',
          'average_last_3_years',
          'average_17_to_21',
          'average_all_inactive_hours',
          'average_weekday_full_day',
          'average_weekend_full_day',
          'average_weekday_day',
          'average_weekend_day',
          'average_weekday_night',
          'average_weekend_night',
          'total_consumption_year',
          'total_consumption_last_year',
          'total_consumption_previous_year',
          'current_calendar_year_sum',
          'last_calendar_year_sum',
          'average_daily_consumption',
          'yearly_trend',
          'yearly_trend_active',
          'yearly_trend_inactive',
          'yoy_ratio',
          'yoy_ratio_current_calendar_year_vs_last',
          'yoy_ratio_weekdays',
          'yoy_ratio_weekends',
          'yoy_ratio_weekday_nights',
          'inactive_active_ratio',
          'weekend_weekday_ratio',
          'night_day_ratio',
          'previous_year_ratio',
          'previous_year_ratio_weekdays',
          'previous_year_ratio_weekends',
          'previous_year_ratio_weekday_nights',
          'weekend_night_weekday_night_ratio',
          'peak',
          'warnings',
        ],
        sortingModel: [{ field: 'average_all', sort: 'desc' }],
        rowGrouping: {
          model: ['matrikel_key'],
        },
        filterModel: {
          items: [],
        },
        columnGroupingModel: [
          {
            groupId: 'activityPatterns',
            headerName: t('columnGroups.activityPatterns.header'),
            description: t('columnGroups.activityPatterns.description'),
            children: [
              { field: 'occupancy' },
              { field: 'daytime_start' },
              { field: 'daytime_end' },
            ],
          },
          {
            groupId: 'averageConsumption',
            headerName: t('columnGroups.averageConsumption.header'),
            description: t('columnGroups.averageConsumption.description'),
            children: [
              { field: 'average_all' },
              { field: 'average_all_last_year' },
              { field: 'current_calendar_year_avg' },
              { field: 'last_calendar_year_avg' },
              { field: 'average_last_3_years' },
              { field: 'average_17_to_21' },
              { field: 'average_all_inactive_hours' },
              { field: 'average_weekday_full_day' },
              { field: 'average_weekend_full_day' },
              { field: 'average_weekday_day' },
              { field: 'average_weekend_day' },
              { field: 'average_weekday_night' },
              { field: 'average_weekend_night' },
            ],
          },
          {
            groupId: 'yearlyTotal',
            description: t('columnGroups.yearlyTotal.description'),
            headerName: t('columnGroups.yearlyTotal.header'),
            children: [
              { field: 'total_consumption_year' },
              { field: 'total_consumption_last_year' },
              { field: 'total_consumption_previous_year' },
              { field: 'current_calendar_year_sum' },
              { field: 'last_calendar_year_sum' },
              { field: 'average_daily_consumption' },
            ],
          },
          {
            groupId: 'yearly_trend',
            description: t('columnGroups.yearly_trend.description'),
            headerName: t('columnGroups.yearly_trend.header'),
            children: [
              { field: 'yearly_trend' },
              { field: 'yearly_trend_active' },
              { field: 'yearly_trend_inactive' },
            ],
          },
          {
            groupId: 'yoy',
            description: t('columnGroups.yoy.description'),
            headerName: t('columnGroups.yoy.header'),
            children: [
              { field: 'yoy_ratio' },
              { field: 'yoy_ratio_current_calendar_year_vs_last' },
              { field: 'yoy_ratio_weekdays' },
              { field: 'yoy_ratio_weekends' },
              { field: 'yoy_ratio_weekday_nights' },
            ],
          },
          {
            groupId: 'consumptionRatio',
            description: t('columnGroups.consumptionRatio.description'),
            headerName: t('columnGroups.consumptionRatio.header'),
            children: [
              { field: 'inactive_active_ratio' },
              { field: 'weekend_weekday_ratio' },
              { field: 'night_day_ratio' },
              { field: 'previous_year_ratio' },
              { field: 'previous_year_ratio_weekdays' },
              { field: 'previous_year_ratio_weekends' },
              { field: 'previous_year_ratio_weekday_nights' },
              { field: 'weekend_night_weekday_night_ratio' },
            ],
          },
          {
            groupId: 'peak',
            headerName: t('columnGroups.peak.header'),
            description: t('columnGroups.peak.description'),
            children: [{ field: 'peak' }],
          },
        ],
      },
    ];
  if (analysisType === 'heat')
    return [
      {
        name: t('presets.overview'),
        order: [
          'favorites',
          'type',
          '__row_group_by_columns_group__',
          'occupancy',
          'daytime_start',
          'daytime_end',
          'last_30_days_average',
          'average_heating_season',
          'average_non_heating_season',
          'total_consumption_year',
          'total_consumption_last_year',
          'warnings',
        ],
        sortingModel: [{ field: 'average_all', sort: 'desc' }],
        rowGrouping: {
          model: ['matrikel_key'],
        },
        filterModel: {
          items: [],
        },
        columnGroupingModel: [
          {
            groupId: 'activityPatterns',
            headerName: t('columnGroups.activityPatterns.header'),
            description: t('columnGroups.activityPatterns.description'),
            children: [
              { field: 'occupancy' },
              { field: 'daytime_start' },
              { field: 'daytime_end' },
            ],
          },
          {
            groupId: 'averageConsumption',
            headerName: t('columnGroups.averageConsumption.header'),
            description: t('columnGroups.averageConsumption.description'),
            children: [
              { field: 'last_30_days_average' },
              { field: 'average_heating_season' },
              { field: 'average_non_heating_season' },
            ],
          },
          {
            groupId: 'yearlyTotal',
            description: t('columnGroups.yearlyTotal.description'),
            headerName: t('columnGroups.yearlyTotal.header'),
            children: [
              { field: 'total_consumption_year' },
              { field: 'total_consumption_last_year' },
            ],
          },
        ],
      },
      {
        name: t('presets.dailyAnalysis'),
        order: [
          'favorites',
          'type',
          '__row_group_by_columns_group__',
          'occupancy',
          'daytime_start',
          'daytime_end',
          'last_30_days_average',
          'average_heating_season',
          'average_heating_season_active',
          'average_heating_season_inactive',
          'warnings',
        ],
        sortingModel: [{ field: 'average_all', sort: 'desc' }],
        rowGrouping: {
          model: ['matrikel_key'],
        },
        filterModel: {
          items: [],
        },
        columnGroupingModel: [
          {
            groupId: 'activityPatterns',
            headerName: t('columnGroups.activityPatterns.header'),
            description: t('columnGroups.activityPatterns.description'),
            children: [
              { field: 'occupancy' },
              { field: 'daytime_start' },
              { field: 'daytime_end' },
            ],
          },
          {
            groupId: 'averageConsumption',
            headerName: t('columnGroups.averageConsumption.header'),
            description: t('columnGroups.averageConsumption.description'),
            children: [
              { field: 'last_30_days_average' },
              { field: 'average_heating_season' },
              { field: 'average_heating_season_active' },
              { field: 'average_heating_season_inactive' },
            ],
          },
        ],
      },
      {
        name: t('presets.trendAnalysis'),
        order: [
          'favorites',
          'type',
          '__row_group_by_columns_group__',
          'occupancy',
          'daytime_start',
          'daytime_end',
          'last_30_days_average',
          'last_30_day_trend',
          'heating_season_trend',
          'heating_season_trend_active',
          'heating_season_trend_inactive',
          'warnings',
        ],
        sortingModel: [{ field: 'average_all', sort: 'desc' }],
        rowGrouping: {
          model: ['matrikel_key'],
        },
        filterModel: {
          items: [],
        },
        columnGroupingModel: [
          {
            groupId: 'activityPatterns',
            headerName: t('columnGroups.activityPatterns.header'),
            description: t('columnGroups.activityPatterns.description'),
            children: [
              { field: 'occupancy' },
              { field: 'daytime_start' },
              { field: 'daytime_end' },
            ],
          },
          {
            groupId: 'averageConsumption',
            headerName: t('columnGroups.averageConsumption.header'),
            description: t('columnGroups.averageConsumption.description'),
            children: [{ field: 'last_30_days_average' }],
          },
          {
            groupId: 'yearly_trend',
            headerName: t('columnGroups.yearly_trend.header'),
            description: t('columnGroups.yearly_trend.description'),
            children: [
              { field: 'last_30_day_trend' },
              { field: 'heating_season_trend' },
              { field: 'heating_season_trend_active' },
              { field: 'heating_season_trend_inactive' },
            ],
          },
        ],
      },
      {
        name: t('presets.detailed'),
        order: [
          'favorites',
          'type',
          '__row_group_by_columns_group__',
          'occupancy',
          'daytime_start',
          'daytime_end',
          'last_30_days_average',
          'average_heating_season',
          'average_non_heating_season',
          'average_heating_season_active',
          'average_heating_season_inactive',
          'average_all',
          'average_all_last_year',
          'current_calendar_year_avg',
          'last_calendar_year_avg',
          'average_last_3_years',
          'average_all_inactive_hours',
          'average_weekday_full_day',
          'average_weekend_full_day',
          'average_weekday_day',
          'average_weekend_day',
          'average_weekday_night',
          'average_weekend_night',
          'total_consumption_year',
          'total_consumption_last_year',
          'total_consumption_previous_year',
          'current_calendar_year_sum',
          'last_calendar_year_sum',
          'average_daily_consumption',
          'yearly_trend',
          'yearly_trend_active',
          'yearly_trend_inactive',
          'heating_season_trend',
          'heating_season_trend_active',
          'heating_season_trend_inactive',
          'yoy_ratio',
          'yoy_ratio_current_calendar_year_vs_last',
          'yoy_ratio_weekdays',
          'yoy_ratio_weekends',
          'yoy_ratio_weekday_nights',
          'inactive_active_ratio',
          'weekend_weekday_ratio',
          'night_day_ratio',
          'previous_year_ratio',
          'previous_year_ratio_weekdays',
          'previous_year_ratio_weekends',
          'previous_year_ratio_weekday_nights',
          'weekend_night_weekday_night_ratio',
          'peak',
          'warnings',
        ],
        sortingModel: [{ field: 'average_all', sort: 'desc' }],
        rowGrouping: {
          model: ['matrikel_key'],
        },
        filterModel: {
          items: [],
        },
        columnGroupingModel: [
          {
            groupId: 'activityPatterns',
            headerName: t('columnGroups.activityPatterns.header'),
            description: t('columnGroups.activityPatterns.description'),
            children: [
              { field: 'occupancy' },
              { field: 'daytime_start' },
              { field: 'daytime_end' },
            ],
          },
          {
            groupId: 'averageConsumption',
            headerName: t('columnGroups.averageConsumption.header'),
            description: t('columnGroups.averageConsumption.description'),
            children: [
              { field: 'last_30_days_average' },
              { field: 'average_heating_season' },
              { field: 'average_non_heating_season' },
              { field: 'average_heating_season_active' },
              { field: 'average_heating_season_inactive' },
              { field: 'average_all' },
              { field: 'average_all_last_year' },
              { field: 'current_calendar_year_avg' },
              { field: 'last_calendar_year_avg' },
              { field: 'average_last_3_years' },
              { field: 'average_all_inactive_hours' },
              { field: 'average_weekday_full_day' },
              { field: 'average_weekend_full_day' },
              { field: 'average_weekday_day' },
              { field: 'average_weekend_day' },
              { field: 'average_weekday_night' },
              { field: 'average_weekend_night' },
            ],
          },
          {
            groupId: 'yearlyTotal',
            description: t('columnGroups.yearlyTotal.description'),
            headerName: t('columnGroups.yearlyTotal.header'),
            children: [
              { field: 'total_consumption_year' },
              { field: 'total_consumption_last_year' },
              { field: 'total_consumption_previous_year' },
              { field: 'current_calendar_year_sum' },
              { field: 'last_calendar_year_sum' },
              { field: 'average_daily_consumption' },
            ],
          },
          {
            groupId: 'yearly_trend',
            description: t('columnGroups.yearly_trend.description'),
            headerName: t('columnGroups.yearly_trend.header'),
            children: [
              { field: 'yearly_trend' },
              { field: 'yearly_trend_active' },
              { field: 'yearly_trend_inactive' },
              { field: 'heating_season_trend' },
              { field: 'heating_season_trend_active' },
              { field: 'heating_season_trend_inactive' },
            ],
          },
          {
            groupId: 'yoy',
            description: t('columnGroups.yoy.description'),
            headerName: t('columnGroups.yoy.header'),
            children: [
              { field: 'yoy_ratio' },
              { field: 'yoy_ratio_current_calendar_year_vs_last' },
              { field: 'yoy_ratio_weekdays' },
              { field: 'yoy_ratio_weekends' },
              { field: 'yoy_ratio_weekday_nights' },
            ],
          },
          {
            groupId: 'consumptionRatio',
            description: t('columnGroups.consumptionRatio.description'),
            headerName: t('columnGroups.consumptionRatio.header'),
            children: [
              { field: 'inactive_active_ratio' },
              { field: 'weekend_weekday_ratio' },
              { field: 'night_day_ratio' },
              { field: 'previous_year_ratio' },
              { field: 'previous_year_ratio_weekdays' },
              { field: 'previous_year_ratio_weekends' },
              { field: 'previous_year_ratio_weekday_nights' },
              { field: 'weekend_night_weekday_night_ratio' },
            ],
          },
          {
            groupId: 'peak',
            headerName: t('columnGroups.peak.header'),
            description: t('columnGroups.peak.description'),
            children: [{ field: 'peak' }],
          },
        ],
      },
    ];
  if (analysisType === 'water')
    return [
      {
        name: t('presets.overview'),
        order: [
          'favorites',
          'type',
          '__row_group_by_columns_group__',
          'occupancy',
          'daytime_start',
          'daytime_end',
          'last_30_days_average',
          'average_all',
          'average_weekday_daytime',
          'average_all_inactive_hours',
          'total_consumption_year',
          'total_consumption_last_year',
          'warnings',
        ],
        sortingModel: [{ field: 'average_all', sort: 'desc' }],
        rowGrouping: {
          model: ['matrikel_key'],
        },
        filterModel: {
          items: [],
        },
        columnGroupingModel: [
          {
            groupId: 'activityPatterns',
            headerName: t('columnGroups.activityPatterns.header'),
            description: t('columnGroups.activityPatterns.description'),
            children: [
              { field: 'occupancy' },
              { field: 'daytime_start' },
              { field: 'daytime_end' },
            ],
          },
          {
            groupId: 'averageConsumption',
            headerName: t('columnGroups.averageConsumption.header'),
            description: t('columnGroups.averageConsumption.description'),
            children: [
              { field: 'last_30_days_average' },
              { field: 'average_all' },
              { field: 'average_weekday_daytime' },
              { field: 'average_all_inactive_hours' },
            ],
          },
          {
            groupId: 'yearlyTotal',
            description: t('columnGroups.yearlyTotal.description'),
            headerName: t('columnGroups.yearlyTotal.header'),
            children: [
              { field: 'total_consumption_year' },
              { field: 'total_consumption_last_year' },
            ],
          },
        ],
      },
      {
        name: t('presets.dailyAnalysis'),
        order: [
          'favorites',
          'type',
          '__row_group_by_columns_group__',
          'occupancy',
          'daytime_start',
          'daytime_end',
          'last_30_days_average',
          'average_all',
          'average_weekday_day',
          'average_all_inactive_hours',
          'inactive_active_ratio',
          'warnings',
        ],
        sortingModel: [{ field: 'average_all', sort: 'desc' }],
        rowGrouping: {
          model: ['matrikel_key'],
        },
        filterModel: {
          items: [
            {
              field: 'average_all',
              operator: '>=',
              value: getTop15Value(transformedData.portfolio_analysis_list),
            },
          ],
        },
        columnGroupingModel: [
          {
            groupId: 'activityPatterns',
            headerName: t('columnGroups.activityPatterns.header'),
            description: t('columnGroups.activityPatterns.description'),
            children: [
              { field: 'occupancy' },
              { field: 'daytime_start' },
              { field: 'daytime_end' },
            ],
          },
          {
            groupId: 'averageConsumption',
            headerName: t('columnGroups.averageConsumption.header'),
            description: t('columnGroups.averageConsumption.description'),
            children: [
              { field: 'last_30_days_average' },
              { field: 'average_all' },
              { field: 'average_weekday_day' },
              { field: 'average_all_inactive_hours' },
            ],
          },
          {
            groupId: 'consumptionRatio',
            headerName: t('columnGroups.consumptionRatio.header'),
            description: t('columnGroups.consumptionRatio.description'),
            children: [{ field: 'inactive_active_ratio' }],
          },
        ],
      },
      {
        name: t('presets.trendAnalysis'),
        order: [
          'favorites',
          'type',
          '__row_group_by_columns_group__',
          'occupancy',
          'daytime_start',
          'daytime_end',
          'last_30_days_average',
          'average_all',
          'yearly_trend',
          'yearly_trend_active',
          'yearly_trend_inactive',
          'warnings',
        ],
        sortingModel: [{ field: 'average_all', sort: 'desc' }],
        rowGrouping: {
          model: ['matrikel_key'],
        },
        filterModel: {
          items: [],
        },
        columnGroupingModel: [
          {
            groupId: 'activityPatterns',
            headerName: t('columnGroups.activityPatterns.header'),
            description: t('columnGroups.activityPatterns.description'),
            children: [
              { field: 'occupancy' },
              { field: 'daytime_start' },
              { field: 'daytime_end' },
            ],
          },
          {
            groupId: 'averageConsumption',
            headerName: t('columnGroups.averageConsumption.header'),
            description: t('columnGroups.averageConsumption.description'),
            children: [
              { field: 'last_30_days_average' },
              { field: 'average_all' },
            ],
          },
          {
            groupId: 'yearly_trend',
            headerName: t('columnGroups.yearly_trend.header'),
            description: t('columnGroups.yearly_trend.description'),
            children: [
              { field: 'yearly_trend' },
              { field: 'yearly_trend_active' },
              { field: 'yearly_trend_inactive' },
            ],
          },
        ],
      },
      {
        name: t('presets.detailed'),
        order: [
          'favorites',
          'type',
          '__row_group_by_columns_group__',
          'occupancy',
          'daytime_start',
          'daytime_end',
          'last_30_days_average',
          'average_all',
          'average_all_last_year',
          'current_calendar_year_avg',
          'last_calendar_year_avg',
          'average_last_3_years',
          'average_all_inactive_hours',
          'average_weekday_full_day',
          'average_weekend_full_day',
          'average_weekday_day',
          'average_weekend_day',
          'average_weekday_night',
          'average_weekend_night',
          'total_consumption_year',
          'total_consumption_last_year',
          'total_consumption_previous_year',
          'current_calendar_year_sum',
          'last_calendar_year_sum',
          'average_daily_consumption',
          'yearly_trend',
          'yearly_trend_active',
          'yearly_trend_inactive',
          'yoy_ratio',
          'yoy_ratio_current_calendar_year_vs_last',
          'yoy_ratio_weekdays',
          'yoy_ratio_weekends',
          'yoy_ratio_weekday_nights',
          'inactive_active_ratio',
          'weekend_weekday_ratio',
          'night_day_ratio',
          'previous_year_ratio',
          'previous_year_ratio_weekdays',
          'previous_year_ratio_weekends',
          'previous_year_ratio_weekday_nights',
          'weekend_night_weekday_night_ratio',
          'peak',
          'warnings',
        ],
        sortingModel: [{ field: 'average_all', sort: 'desc' }],
        rowGrouping: {
          model: ['matrikel_key'],
        },
        filterModel: {
          items: [],
        },
        columnGroupingModel: [
          {
            groupId: 'activityPatterns',
            headerName: t('columnGroups.activityPatterns.header'),
            description: t('columnGroups.activityPatterns.description'),
            children: [
              { field: 'occupancy' },
              { field: 'daytime_start' },
              { field: 'daytime_end' },
            ],
          },
          {
            groupId: 'averageConsumption',
            headerName: t('columnGroups.averageConsumption.header'),
            description: t('columnGroups.averageConsumption.description'),
            children: [
              { field: 'last_30_days_average' },
              { field: 'average_all' },
              { field: 'average_all_last_year' },
              { field: 'current_calendar_year_avg' },
              { field: 'last_calendar_year_avg' },
              { field: 'average_last_3_years' },
              { field: 'average_all_inactive_hours' },
              { field: 'average_weekday_full_day' },
              { field: 'average_weekend_full_day' },
              { field: 'average_weekday_day' },
              { field: 'average_weekend_day' },
              { field: 'average_weekday_night' },
              { field: 'average_weekend_night' },
            ],
          },
          {
            groupId: 'yearlyTotal',
            description: t('columnGroups.yearlyTotal.description'),
            headerName: t('columnGroups.yearlyTotal.header'),
            children: [
              { field: 'total_consumption_year' },
              { field: 'total_consumption_last_year' },
              { field: 'total_consumption_previous_year' },
              { field: 'current_calendar_year_sum' },
              { field: 'last_calendar_year_sum' },
              { field: 'average_daily_consumption' },
            ],
          },
          {
            groupId: 'yearly_trend',
            description: t('columnGroups.yearly_trend.description'),
            headerName: t('columnGroups.yearly_trend.header'),
            children: [
              { field: 'yearly_trend' },
              { field: 'yearly_trend_active' },
              { field: 'yearly_trend_inactive' },
            ],
          },
          {
            groupId: 'yoy',
            description: t('columnGroups.yoy.description'),
            headerName: t('columnGroups.yoy.header'),
            children: [
              { field: 'yoy_ratio' },
              { field: 'yoy_ratio_current_calendar_year_vs_last' },
              { field: 'yoy_ratio_weekdays' },
              { field: 'yoy_ratio_weekends' },
              { field: 'yoy_ratio_weekday_nights' },
            ],
          },
          {
            groupId: 'consumptionRatio',
            description: t('columnGroups.consumptionRatio.description'),
            headerName: t('columnGroups.consumptionRatio.header'),
            children: [
              { field: 'inactive_active_ratio' },
              { field: 'weekend_weekday_ratio' },
              { field: 'night_day_ratio' },
              { field: 'previous_year_ratio' },
              { field: 'previous_year_ratio_weekdays' },
              { field: 'previous_year_ratio_weekends' },
              { field: 'previous_year_ratio_weekday_nights' },
              { field: 'weekend_night_weekday_night_ratio' },
            ],
          },
          {
            groupId: 'peak',
            headerName: t('columnGroups.peak.header'),
            description: t('columnGroups.peak.description'),
            children: [{ field: 'peak' }],
          },
        ],
      },
    ];
};
